const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/sagas/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        appointmentBookingSuccess: 'Termin erfolgreich gebucht',
        cancelAppointmentSuccess: 'Termin erfolgreich storniert',
        finalizeEcheckinSuccess: 'Online Checkin erfolgreich abgeschlossen',
        saveEcheckinSuccess: 'Online Checkin Kapitel erfolgreich gespeichert',
        oldFormData: 'Veraltete Formulardaten - bitte neu anmelden',
        appAuthLoginFailed: 'Anmeldung ist fehlgeschlagen',
    },
    __RELATIVE_SOURCE_FILE__
);
